var $5abae18a692b5c91$exports = {};
let $5abae18a692b5c91$var$introduction = false;
document.querySelector('.js-pvc').addEventListener('click', ()=>{
    localStorage.removeItem('score-pvc');
    $5abae18a692b5c91$var$introduction = true;
    localStorage.setItem('introduction', JSON.stringify($5abae18a692b5c91$var$introduction));
    window.close('index.html');
    window.open('pvc.html');
});
document.querySelector('.js-pvp').addEventListener('click', ()=>{
    localStorage.removeItem('score-pvp');
    $5abae18a692b5c91$var$introduction = true;
    localStorage.setItem('introduction', JSON.stringify($5abae18a692b5c91$var$introduction));
    window.close('index.html');
    window.open('pvp.html');
});
window.addEventListener("orientationchange", function() {
    if (screen.orientation.angle !== 0) screen.orientation.lock("portrait").catch((err)=>console.log(err));
});


//# sourceMappingURL=Tic-tac-toe.ccb7c5d6.js.map
